import { ApplicationStatus } from "@humanex/interfaces";
import { cn } from "@humanex/ui/libs";

const STATUS_BADGE: Record<string, string> = {
  [ApplicationStatus.DEPOSIT_PENDING]: "border-accent-500 text-accent-800 bg-accent-100",
  [ApplicationStatus.SUBMITTED]: "border-gray-200 text-gray-600 bg-gray-100",
  [ApplicationStatus.UNDER_REVIEW]: "border-secondary-400 text-secondary-600 bg-secondary-50",
  [ApplicationStatus.NEEDS_SUPPLEMENT]: "border-accent-500 text-accent-800 bg-accent-100",
  [ApplicationStatus.ACCEPTED]: "border-success-500 text-success-800 bg-success-100",
  [ApplicationStatus.REJECTED]: "border-error-500 text-error-800 bg-error-100",
  [ApplicationStatus.CANCELLED]: "border-error-500 text-error-800 bg-error-100"
};

const STATUS_LABEL: Record<string, string> = {
  [ApplicationStatus.DEPOSIT_PENDING]: "Chờ thanh toán",
  [ApplicationStatus.SUBMITTED]: "Đã nộp",
  [ApplicationStatus.UNDER_REVIEW]: "Đang xét duyệt",
  [ApplicationStatus.NEEDS_SUPPLEMENT]: "Cần bổ sung",
  [ApplicationStatus.ACCEPTED]: "Chấp nhận",
  [ApplicationStatus.REJECTED]: "Từ chối",
  [ApplicationStatus.CANCELLED]: "Đã hủy",
  WITHDRAWN: "Rút hồ sơ"
};

interface ApplicationStatusBadgeProps {
  status: string;
  className?: string;
}

export function ApplicationStatusBadge({ status, className }: ApplicationStatusBadgeProps) {
  const statusLower = status.toLowerCase();
  let badgeClass = STATUS_BADGE[status] ?? "border-gray-200 text-gray-600 bg-gray-100";

  // Any status containing "review" gets secondary
  if (!STATUS_BADGE[status] && statusLower.includes("review")) {
    badgeClass = "border-secondary-400 text-secondary-600 bg-secondary-50";
  }

  return (
    <span
      className={cn(
        "rounded-full px-2.5 py-0.5 text-xs font-medium inline-flex items-center border",
        badgeClass,
        className
      )}
    >
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
